import { sectionRoutes } from '../helpers';

export const HERMES_ROUTES = [
  { path: 'hermes', redirect: { name: 'AdminHermesOverview' } },
  ...sectionRoutes({
    meta: { adminTab: 'Hermes' },
    tabKey: 'hermesTab',
    routes: [
      ['hermes/overview', 'AdminHermesOverview', 'overview'],
      ['hermes/runs', 'AdminHermesRuns', 'runs'],
      ['hermes/runs/:runId(\\d+)/:tab(units|results|effects|frames)?', 'AdminHermesRun', 'runs'],
      ['hermes/templates', 'AdminHermesTemplates', 'templates'],
      ['hermes/templates/:templateId(new|\\d+)/:section?', 'AdminHermesTemplate', 'templates'],
      ['hermes/executors', 'AdminHermesExecutors', 'executors'],
      ['hermes/executors/:executorKey', 'AdminHermesExecutor', 'executors'],
      ['hermes/approvals', 'AdminHermesApprovals', 'approvals'],
      ['hermes/approvals/:effectId(\\d+)', 'AdminHermesApproval', 'approvals'],
      ['hermes/schedules', 'AdminHermesSchedules', 'schedules'],
      ['hermes/schedules/:scheduleId(new|\\d+)', 'AdminHermesSchedule', 'schedules'],
      ['hermes/hats', 'AdminHermesHats', 'hats'],
      ['hermes/hats/:hatName([a-z0-9_-]+)', 'AdminHermesHat', 'hats'],
      ['hermes/tests', 'AdminHermesTests', 'tests'],
      ['hermes/console', 'AdminHermesConsole', 'console'],
    ],
  }),
];
